/* @flow */
import React from 'react';
// $FlowIgnore
import { connect } from 'react-redux';
import { canDownloadEntities } from 'containers/decorators';
import DownloadDropdown from 'components/DownloadDropdown';
import { spinnable } from 'components/UIKit/decorators';
import Button from 'components/UIKit/Button/ButtonTemplate';
import DownloadIcon from 'components/icons/DownloadIcon';
import { Spinner } from 'components/UIKit/Spinner';

function EntityTypesDownloadContainer({
  setIsSpinning,
  isSpinning,
  downloadEntities,
  downloadEntitiesByIds,
  entityTypes,
  options,
  marginOffset,
  disabled,
  children,
  downloadAll,
  id,
  customDataTestID,
}: any): React.Element {
  return (
    <DownloadDropdown
      disabled={disabled}
      marginOffset={marginOffset}
      download={
        async format => {
          if (downloadAll) {
            await downloadEntities({ entityTypes, format, ...options });
          } else {
            await downloadEntitiesByIds({ ids: [id], format, ...options });
          }
        }
      }
      formats={['tsv', 'json']}
      setIsSpinning={setIsSpinning}
      >
      <Button
        customDataTestID={customDataTestID}
        disabled={disabled || isSpinning}
        PrefixComponent={isSpinning
          ? <Spinner style={{ height: '1rem', width: '1rem', marginRight: '2px' }} />
          : <DownloadIcon />}
        >
        { children || entityTypes.join(', ') }
      </Button>
    </DownloadDropdown>
  );
}

export default connect(({
  details: {
    item: { id },
  },
}) => ({ id }))(canDownloadEntities(spinnable(EntityTypesDownloadContainer)));
